import { React, useState, useEffect } from 'react';
import GeoGebraMySol from '../components/GeoGebraMySol';
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom';
import ViewMyAnswerItem from '../components/ViewMyAnswerItem';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
import { VscCheck,VscRocket } from "react-icons/vsc";

const CategoryProblemMy = ()=> {
       const navigateto=useNavigate();
       const {doorCategoryProbIDMy}=useParams();
       const {categoryURL, categoryTitle, problemCode, problem, category, myAnswerList} = useLocation().state;
       const {myConstructionStep, myAnswerRaw, myPointConstruction, errAns} = ViewMyAnswerItem({"answerMark": doorCategoryProbIDMy});
       const location = useLocation();
       const [selectedAnswer, setSelectedAnswer] = useState();
       const [randomString1, setRandomString1] = useState();
       const [myConstruct, setMyConstruct] = useState('');
       const [flag, setFlag] =useState('');

       const splitContent = (sentence) => {
              const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
              const matches = sentence.matchAll(InlineMathRegex);
              let lastIndex = 0;
              const contentArray = [];
              
              for (const match of matches) {
                     const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
                     const restOfContent = sentence.substring(lastIndex, match.index);
                     
                     contentArray.push(restOfContent, InlineMathContent);
                     lastIndex = match.index + match[0].length;
              }
              
              if (lastIndex < sentence.length) {
                     contentArray.push(sentence.substring(lastIndex));
              }
              
              return <div>{contentArray}</div>;
       };

       function ProblemLinkC ({LinkTitle, LinkId}) {
              return(
                     <div className="subject-sidebar-4">
                            {LinkId === problemCode
                                   ? <b style ={{color:'red'}}>{LinkTitle} <VscCheck/> <VscRocket/></b>
                                   : <Link to={`/door/category/problem/`} state={{
                                                 "categoryURL": categoryURL,
                                                 "categoryTitle": categoryTitle,
                                                 "problemCode": LinkId
                                          }}>
                                                 {LinkTitle}
                                          </Link>
                            }
                     </div>
              )
       }

       function ProblemLink ({LinkTitle, LinkId}) {
              return(
                     <div className="subject-sidebar-4">
                            <Link to={`/door/category/problem/`} state={{
                                   "categoryURL": categoryURL,
                                   "categoryTitle": categoryTitle,
                                   "problemCode": LinkId
                            }}>
                                   {LinkTitle}
                            </Link>
                     </div>
              )
       }

       useEffect(() => {
              setMyConstruct(myConstructionStep);
              setFlag(doorCategoryProbIDMy);
       },[myConstructionStep])

       useEffect(() => {
              const revivalData = () => {
                     const letters = '1234567890';
                     let randomString1l = '';
                     for (let i = 0; i < 3; i++) {
                            randomString1l += letters[Math.floor(Math.random() * letters.length)];
                     }
                     setRandomString1(randomString1l);
              };
              revivalData();
       },[doorCategoryProbIDMy])

       return(
              <div className="App-full-row-container" key={problem.problemCode}>
                     <div className="left-menu-box-1">
                            <h4 style={{fontWeight:"bolder", color:"orange" ,marginTop:"22px", marginBottom:"15px", marginLeft:"5px"}}>
                                   {categoryTitle}
                            </h4>
                            {
                                   category && category.map(problem => {
                                          return(
                                                 <div key={problem.problemCode}>
                                                        {problem.problemCode === problemCode
                                                               ? <ProblemLinkC LinkTitle={problem.problemTitle && splitContent(problem.problemTitle)} LinkId={problem.problemCode} /> 
                                                               : <ProblemLink LinkTitle={problem.problemTitle && splitContent(problem.problemTitle)} LinkId={problem.problemCode} />
                                                        }
                                                 </div>
                                          )
                                   })
                            }
                     </div>
                     <div className="content-box-1">
                            <div className="problem" key={myAnswerRaw.answerMark}>
                                   {errAns 
                                          ? navigateto("/login", {state:{"from": location}}, {replace: true})
                                          : <div className="content-fit">
                                                 <h4>{myAnswerRaw && `${myAnswerRaw.solvingTime.substring(6,10)}년 ${myAnswerRaw.solvingTime.substring(3,5)}월 ${myAnswerRaw.solvingTime.substring(0,2)}일 ${myAnswerRaw.solvingTime.substring(12,17)}의 풀이`}</h4>
                                                 <div>
                                                        <select value={selectedAnswer} style={{height:"36px"}} onChange={(e) => setSelectedAnswer(e.target.value)}>
                                                               <option value>문제를 푼 때를 선택하세요.</option>
                                                               {myAnswerList.map(myAns => {
                                                                      return <option value={myAns.answerMark} key={myAns.answerMark}>
                                                                             {myAns.solvingTime.substring(6,10)}년 {myAns.solvingTime.substring(3,5)}월 {myAns.solvingTime.substring(0,2)}일 {myAns.solvingTime.substring(12,17)}
                                                                      </option>
                                                               })}
                                                        </select>
                                                        <button 
                                                               className='button' 
                                                               style={{marginLeft:"10px"}}
                                                               onClick={() => navigateto(`/door/category/problem/my/${selectedAnswer}`, {state: {
                                                                      "categoryURL": categoryURL,
                                                                      "categoryTitle": categoryTitle,
                                                                      "problemCode": problemCode,
                                                                      "problem": problem,
                                                                      "category": category,
                                                                      "myAnswerList": myAnswerList
                                                               }})}
                                                        >
                                                               풀이 보기
                                                        </button>
                                                 </div>
                                                 <div key={flag}>
                                                        {myConstruct.length !== 0
                                                               ? <GeoGebraMySol
                                                                      idIn={problem.problemCode}
                                                                      customToolBarIn={problem.customToolBar}
                                                                      allowStyleBarIn={problem.allowStyleBar}
                                                                      ggbBase64In={problem.problemContent}
                                                                      myPointAnswer={myPointConstruction}
                                                                      myAnswerStep={myConstruct}
                                                                      problemType={problem.problemType}
                                                               />
                                                               : "Loading"
                                                        }
                                                 </div>
                                                 <div className='horizontal-flex-container'>
                                                        <button 
                                                               className='button'
                                                               onClick={() => navigateto(`/door/category/problem/`, {state: {
                                                                      "categoryURL": categoryURL,
                                                                      "categoryTitle": categoryTitle,
                                                                      "problemCode": problemCode
                                                               }})}
                                                        >
                                                               문제로 돌아가기
                                                        </button>
                                                        {(problem.problemType === 1 || problem.problemType === 2)
                                                               ? <button 
                                                                      className='button'
                                                                      onClick={() => navigateto(`/door/category/problem/my/animation/${doorCategoryProbIDMy}`, {state:{
                                                                             "categoryURL": categoryURL,
                                                                             "categoryTitle": categoryTitle,
                                                                             "problemCode": problemCode,
                                                                             "problem": problem,
                                                                             "category": category,
                                                                             "myAnswerList": myAnswerList,
                                                                             "doorCategoryProbIDMy": doorCategoryProbIDMy,
                                                                             "myConstructionStep": myConstructionStep,
                                                                             "myPointConstruction": myPointConstruction,
                                                                             "myAnswerRaw":myAnswerRaw
                                                                      }})}
                                                               >
                                                                      풀이 과정 보기
                                                               </button>
                                                               : null
                                                        }
                                                 </div>
                                          </div>
                                   }
                                   <br/>
                            </div>
                     </div>
              </div>
       );
};

export default CategoryProblemMy;
